import { useQuery } from '@tanstack/react-query';
import { configApi } from '../api/config.api';
import { MINUTE } from '@shared/utils';

export const useConfig = () => {
  return useQuery({
    queryKey: ['configs'],
    queryFn: () => configApi.getList(),
    staleTime: 60*24 * MINUTE,
    meta: { persist: true },
  });
};
